import { defineMessages } from 'react-intl';

export default defineMessages({
  allergenDisclaimer: {
    id: 'ordering.productInfo.allergenDisclaimer',
    defaultMessage:
      'We cannot guarantee that any unpackaged products served in our stores are allergen-free because we use shared equipment to store, prepare, and serve them. Customers with allergies can find ingredient information for products on the labels of our packaged products or online at Starbucks.com/menu.',
    description:
      'Legal disclaimer about allergen contact in the processing and handling of consumable products.',
  },
  allergensTitle: {
    id: 'ordering.shared.allergensTitle',
    defaultMessage: 'Allergens',
    description: 'The title of a section containing allergen information',
  },
  backToContent: {
    id: 'ordering.shared.backToContent',
    defaultMessage: 'Back to content',
    description:
      'Text of link allowing user to return to content after reading a disclaimer',
  },
  caffeineDisclaimer: {
    id: 'ordering.menu.caffeine.disclaimer',
    defaultMessage: '** Caffeine is an approximate value.',
    description: 'Disclaimer indicating the caffeine value is approximate',
  },
  disclaimerHeading: {
    id: 'ordering.menu.nutrition.disclaimerHeading',
    defaultMessage: 'Nutrition disclaimers',
    description: 'Heading above nutrition disclaimers',
  },
  generalNutritionDisclaimer: {
    id: 'ordering.menu.nutrition.disclaimer',
    defaultMessage:
      'Nutrition information is calculated based on our standard recipes. Because our products may be customized, exact information may vary.',
    description: 'The legal disclaimer about variance in nutritional content',
  },
  dailyValuesDisclaimer: {
    id: 'ordering.menu.dailyValues.disclaimer',
    defaultMessage:
      '2,000 calories a day is used for general nutrition advice, but calorie needs vary.',
    description: 'Disclaimer regarding daily values percentages',
  },
  ingredientsTitle: {
    id: 'ordering.ingredients.title',
    defaultMessage: 'Ingredients',
    description: 'The title of a section containing ingredient information',
  },
  nutritionTitle: {
    id: 'ordering.menu.nutrition.title',
    defaultMessage: 'Nutrition',
    description: 'The title of a section containing nutritional information',
  },
  nutritionNotAvailable: {
    id: 'ordering.menu.nutrition.notAvailable',
    defaultMessage: 'Not available for this item',
    description:
      'The the message presented to a customer when nutrition info is not avaialble',
  },
  beveragesPdfBlurb: {
    id: 'ordering.menu.nutrition.beveragesPdfBlurb',
    defaultMessage:
      'This guide doesn’t just tell you about the caffeine content; it contains nutritional information on many of our classic beverages you enjoy at Starbucks. But we’ve included the caffeine info as well, in case you were wondering.',
    description:
      'Describes the contents of the PDF of all beverage nutrition content.',
  },
  foodPdfBlurb: {
    id: 'ordering.menu.nutrition.foodPdfBlurb',
    defaultMessage:
      'This guide contains nutritional information – including protein, sugar, and carbohydrate content – for many of the fresh food products available in Starbucks stores in the UK and Ireland.',
    description:
      'Describes the contents of the PDF of all food nutrition content.',
  },
});
